
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators'
import store from '../../index'

export interface userInfoTypes {
  areaId?: number;
  areaName?: string;
  confirmTimeProtocol?: string;
  createDate?: string;
  currencyCode?: string;
  customServiceId?: number;
  dbLink?: string;
  enableRecommend?: number;
  id?: number;
  mchAddress?: string;
  mchDesc?: string;
  mchLogo?: string;
  mchName?: string;
  mchPhone?: string;
  mchQq?: string;
  mchWebSite?: string;
  modifyDate?: string;
  modifyRateDate?: string;
  modifyRefDate?: string;
  parentMchId: number;
  realInventory?: string;
  serviceLevel?: string;
  serviceSpeed?: string;
  status?: number;
  systemGrade?: string;
  systemRecommended?: string;
  vip?: number;
  cookie?: string;
  popContent?: {
    areaIds: string;
    areaLimitType: number;
    createDate: number;
    effectEndDate: string;
    effectStartDate: string;
    id: number;
    modifyDate: number;
    popContent: string;
    popLink: string;
    popTitle: string;
    popType: 1 | 2; // 弹窗类型（1-图片 2-文件）
    rankOrder: number;
    showType: 0 | 1 | 2; // 显示类型（0-只显示一次 1-每天显示一次 2-没登录显示一次）
    state: -1 | 0 | 1; // 状态（-1-删除 0-下架 1-上架）
  }
}

interface userInfoType {
  userInfo: userInfoTypes
}

@Module({
  name: 'User',
  dynamic: true,
  store
})
export default class User extends VuexModule implements userInfoType {
  userInfo: userInfoTypes = {
    parentMchId: NaN
  }

  @Mutation
  SET_USER_INFO (userInfo?: userInfoTypes): void {
    if (userInfo) {
      this.userInfo = userInfo
      sessionStorage.setItem('USER_INFO', JSON.stringify(userInfo))
    } else {
      const info = sessionStorage.getItem('USER_INFO')
      if (info) {
        this.userInfo = JSON.parse(info)
      }
    }
  }

  // 退出清除信息  用户自己的信息
  @Mutation
  REMOVE_USER_INFO (): void {
    this.userInfo = {
      parentMchId: NaN
    }
    sessionStorage.removeItem('USER_INFO')
  }
}

export const UserStore = getModule(User)

UserStore.SET_USER_INFO()
